<li><pux-translate tag="span" :text="getModel"></pux-translate><span>{{ last ? "" : "," }}</span></li>